import { type ShortcodeType } from '@Types/Blocks/Shortcode';

import { useEffect, useState } from 'react';

import apiFetch from '@wordpress/api-fetch';

export default function Shortcode({ block }: { block: ShortcodeType }) {
	const { id } = block;
	const [shortcode, setShortcode] = useState<any>();

	useEffect(() => {
		const _shortcode: Promise<any> = apiFetch({
			path: '/minos/v2/getshortcode/',
			method: 'POST',
			data: { args: block.shortcode },
		});
		_shortcode.then((json: string) => {
			setShortcode(json);
		});
	}, [block]);

	return (
		<section
			data-aos='fade-up'
			id={id}
			className='minos-grid relative py-5 tablet:py-12 desktop:py-24'
		>
			{shortcode}
		</section>
	);
}
